import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa'; // Importing the edit icon
import './verify.css';

const RecruiterVerify = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        emailOrPhone: location.state?.emailOrPhone || '',
        verificationCode: '',
    });
    const [isEditing, setIsEditing] = useState(false); // State to toggle editing mode
    const [originalEmailOrPhone, setOriginalEmailOrPhone] = useState(location.state?.emailOrPhone || '');
    const [isVerifyEnabled, setIsVerifyEnabled] = useState(true); // State to disable verify button

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'emailOrPhone' && e.target.value !== originalEmailOrPhone) {
            setIsVerifyEnabled(false); // Disable verify button if email or phone is edited
        }
    };

    const handleEditClick = () => {
        setIsEditing(true); // Enable editing mode
    };

    const handleBlur = () => {
        setIsEditing(false); // Disable editing mode on blur
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authRecruiter/verify', formData);
            // console.log(response.data);
            const { token } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('notification', 'Signup successful !');
            navigate('/recruiter/home');
        } catch (error) {
            console.error(error);
            setError(error.response.data.message);
        }
    };

    const handleResend = async () => {
        setIsVerifyEnabled(false); // Enable verify button after resend

        try {
            const payload = {
                emailOrPhone: originalEmailOrPhone,
                newEmailOrPhone: formData.emailOrPhone
            };
            const response = await axios.post('/api/authRecruiter/resend-verification', payload);
            // console.log(response.data);
            // window.location.reload(); // Reload the page
            setError('Verification code resent successfully.');
            setIsVerifyEnabled(true); // Enable verify button after resend
        } catch (error) {
            console.error(error);
            setError(error.response.data.message);
        }
    };

    return (
        <div className="verify-container">
            <form onSubmit={handleSubmit}>
                <h2>Verify</h2>

                {/* Email or Phone with Edit Icon */}
                <div className="editable-field">
                    {isEditing ? (
                        <input
                            type="text"
                            name="emailOrPhone"
                            value={formData.emailOrPhone}
                            onChange={handleChange}
                            onBlur={handleBlur} // Exit editing mode when input loses focus
                            autoFocus
                        />
                    ) : (
                        <p>
                            Verification Code sent to: <strong>{formData.emailOrPhone}</strong>
                            <FaEdit className="edit-icon" onClick={handleEditClick} />
                        </p>
                    )}
                </div>

                <input
                    type="text"
                    name="verificationCode"
                    placeholder="Verification Code"
                    value={formData.verificationCode}
                    onChange={handleChange}
                    required
                />
                <div className="error-message">
                    <p>{error}</p>
                </div>
                <button type="submit" className={isVerifyEnabled ? "" : "verify-enabled"}
                enabled={isVerifyEnabled}>Verify</button>
                <button type="button" onClick={handleResend}>
                    Resend Verification Code
                </button>
            </form>
        </div>
    );
};

export default RecruiterVerify;
